import { UserCommentProps } from "./UserComment.types"
import "./UserComment.css"
import EllipsisMenu from "../EllipsisMenu/EllipsisMenu"
import { useState } from "react"

const UserComment = (props: UserCommentProps) => {

  const { username, comment, onClick, onDelete } = props

  const [showMenu, setShowMenu] = useState<boolean>(false)

  const getUserInitials = () => {
    const names = username.split(" ")
    const initials = names.map(name => name.charAt(0).toUpperCase()).join("")
    return initials
  }

  return (
    <div
      className="user-comment-item"
      style={{cursor: onClick === undefined ? "default" : "pointer" }}
      onClick={onClick}
    >
      <div className="user-comment-profile">
        <p className="user-comment-profile">{getUserInitials()}</p>
      </div>
      <div className="user-comment">
        <div className="user-comment-header">
          <p className="comment-username-label">{username}</p>
          {onDelete !== undefined && (
            <EllipsisMenu
              ellipsisMenu={{
                items: [{
                  item: "Delete",
                  onClick: () => onDelete()
                }],
                showMenu: showMenu,
                onClick: () => setShowMenu(true),
                onHide: () => setShowMenu(false),
              }}
            />
          )}

        </div>
        <p className="comment-label">{comment}</p>
      </div>
    </div>
  )
}

export default UserComment